{
  "it": {
    "survey": {
      "actions": {
        "add": "Aggiungi nuovo",
        "addDescription": "Aggiungi descrizione",
        "close": "Chiudi",
        "create": "Crea",
        "createNew": "Nuovo",
        "delete": "Elimina",
        "deleteCount": "Sta per eliminare {count} questionario. È sicuro? | Sta per eliminare {count} questionari. È sicuro?",
        "deleteMultiple": "Elimina...",
        "delete_cancel": "Annulla",
        "delete_surveys": "Elimina questionario | Elimina questionari",
        "importTemplate": "Importa",
        "newSurvey": "Questionario",
        "publish": "Pubblica",
        "publishCustomer": "Pubblica per i clienti",
        "revokeAccess": "Revoca accesso",
        "save": "Salva",
        "selectAll": "Seleziona tutti i {total} questionari",
        "send": "Invia",
        "sendCustomer": "Invia al cliente",
        "submit": "Salva",
        "surveys_collapse": "Comprimi questionari",
        "surveys_expand": "Espandi questionari",
        "unSelectAll": "Svuota selezione.",
        "unpublish": "Annulla pubblicazione"
      },
      "attributes": {
        "description": "Titolo interno",
        "title": "La Sua domanda"
      },
      "labels": {
        "NPSOverview": "Panoramica NPS",
        "NPSQuestion": "Quanto è probabile che Lei raccomandi {name} a un amico o a un collega?",
        "addQuestion": "Domanda",
        "answerRequired": "Risposta (obbligatoria)",
        "answer_later": "Rispondi più tardi",
        "answeredAt": "Risposto il",
        "average_score": "Punteggio medio",
        "clientTeam": "Il team di {name}",
        "comments": "Commenti o suggerimenti? (facoltativo)",
        "completedTime": "Risposto",
        "customer": "Cliente",
        "customer_status": "Stato",
        "detractors": "Detrattori",
        "dissatisfied": "Insoddisfatto",
        "extremelyLikely": "Estremamente probabile",
        "lets_go": "Inizia",
        "list": "Elenco",
        "mostRecentAnswers": "Risposte più recenti",
        "neither_satisfied_nor_dissatisfied": "Né soddisfatto né insoddisfatto",
        "neutrals": "Neutrali",
        "noAnswers": "Ancora nessuna risposta",
        "noSurveyFeedback": "Nessun commento o suggerimento",
        "noSurveysYet": "Ancora nessun questionario. Crei il Suo primo questionario per iniziare.",
        "noUnitsClick": "Ancora nessuna unità, faccia clic qui per aggiungere",
        "no_opinion": "Nessuna opinione",
        "notAtAllLikely": "Per niente probabile",
        "nps": "NPS",
        "numberAnswered": "{answered} su {total} risposte",
        "obligatory": "Rendere il questionario obbligatorio per i clienti",
        "pendingSurveys": " Abbiamo bisogno del Suo feedback",
        "promoters": "Promotori",
        "publishNow?": "Pubblicare ora?",
        "published": "Pubblicato",
        "publishedCount": "Pubblica questo questionario per il cliente | Pubblica {count} questionari per i clienti",
        "question": "Domanda",
        "question_number": "Domanda {current_number} di {total_questions}",
        "questions": "Domande",
        "respondents": "Nessun rispondente | 1 rispondente | {count} rispondenti",
        "response": "Risposta",
        "responseTime": "Tempo di risposta",
        "responses": "Risposte",
        "revokeAccessCount": "Revoca l'accesso a questo questionario per il cliente | Revoca l'accesso a questo questionario per {count} clienti",
        "satisfied": "Soddisfatto",
        "saveExplainer": "Rendere visibile questo questionario ai Suoi clienti? Oppure salvarlo e pubblicarlo più tardi?",
        "scoreBreakdown": "Ripartizione del punteggio",
        "selectOneUnit": "Selezioni almeno 1 questionario",
        "selectUnits": "Seleziona unità",
        "selected": "{selected} questionario è selezionato. | {selected} questionari sono selezionati.",
        "sendCount": "Invia questo questionario al cliente | Invia i questionari a {count} clienti",
        "sendExplainer": "I Suoi clienti lo vedranno nella loro dashboard",
        "sendNow?": "Inviare ora?",
        "sent": "Inviato",
        "sentCustomer": "Inviato al cliente",
        "showSurveysFor": "Mostra questionari per",
        "showingResultsFor": "Risultati visualizzati per",
        "step0Title": "Quale progetto modello e questionario desidera utilizzare?",
        "step2Subtitle": "Così i Suoi clienti sapranno qual è lo scopo di questo questionario",
        "step2Title": "Aggiunga una breve introduzione",
        "step3Subtitle": "Selezioni il Suo progetto per includere tutte le Sue unità in una volta sola.",
        "step3Title": "Per quali unità desidera creare questo questionario?",
        "survey": "Questionario",
        "surveyAlreadyAnswered": "Il questionario ha già ricevuto una risposta. Grazie per il Suo feedback.",
        "surveyAnswer": "Feedback",
        "surveyNotCompleted": "Il questionario non è ancora completato.",
        "surveys": "Questionari",
        "surveysCount": "{count} questionario | {count} questionari",
        "surveys_all_projects": "Questionari di tutti i progetti",
        "tabOverview": "Panoramica",
        "tabSurveys": "Questionari",
        "thankYou": "Grazie per il Suo feedback.",
        "title": "Domanda",
        "titles_must_be_unique": "Ci sono domande duplicate. Le domande devono essere uniche.",
        "totalSelected": "Tutti i {total} questionari sono selezionati.",
        "unanswered": "Senza risposta",
        "unit": "Unità",
        "unitSelected": "Ancora nessuna unità selezionata | Un'unità selezionata | {count} unità selezionate",
        "units": "Unità",
        "unitsWithoutSurvey": "{count} unità senza questionario | {count} unità senza questionari",
        "unpublishedCount": "Annulla la pubblicazione di questo questionario | Annulla la pubblicazione di {count} questionari",
        "very_dissatisfied": "Molto insoddisfatto",
        "very_satisfied": "Molto soddisfatto",
        "visibility": "Visibilità",
        "yourAnswers": "Le Sue risposte",
        "yourQuestion": "La Sua domanda"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Chieda un feedback ai Suoi clienti",
            "title": "Crei il Suo primo questionario"
          },
          "none": {
            "subtitle": "Chieda un feedback ai Suoi clienti",
            "title": "Nessun questionario trovato"
          }
        }
      },
      "toasts": {
        "bulk_create": "Questionario creato con successo | Questionari creati con successo",
        "bulk_delete": "Questionario eliminato con successo | Questionari eliminati con successo",
        "bulk_update": "Questionario aggiornato con successo | Questionari aggiornati con successo",
        "update": "Questionario aggiornato con successo"
      },
      "validation": {
        "needName": "Inserisca una domanda",
        "needQuestion": "Aggiunga almeno 1 domanda",
        "selectUnit": "Selezioni almeno 1 unità"
      }
    }
  }
}
